import router from '@/router'

import {
  SET_PLACES_LIST,
  SET_PLACE_DETAILS,
  SET_ACTIVE_PLACE,
  TOGGLE_MODE,
  TOGGLE_LOADING
} from '@/store/mutation-types'
import service from '@/service'
import parseFilter from '@/assets/js/parseFilter'
import toggleLoading from '@/store/toggleLoading'

const MODES = ['map', 'tile']
const extractPageFromUrl = url => {
  const [, page] = url.match(/.*?page=(\d*$)/) || []
  return page
}

const state = {
  list: [],
  details: [],
  active: -1,
  mode: 0,
  setActiveLoading: false
}

const getters = {
  places (state, getters, { filters = {} }) {
    return state.list
      .map(item => ({
        ...item,
        visible: item.tags.some(tag => !filters.filters.length || filters.filters.includes(tag)),
        active: item.id === state.active
      }))
  },
  mode (state) {
    return MODES[state.mode]
  },
  isTileList (state, getters) {
    return getters.mode === MODES[1]
  },
  activePlace (state) {
    return state.details.find(item => item.id === state.active) || {}
  }
}

const mutations = {
  ...toggleLoading,
  [SET_PLACES_LIST] (state, list = []) {
    const createPlace = place => ({
      ...place,
      isVideo: place.is_video,
      position: { lat: parseFloat(place.lat), lng: parseFloat(place.lng) },
      tags: place.tags.map(parseFilter),
      photo: place.photos[0]
    })

    state.list = [...state.list, ...list.map(createPlace)]
  },
  [SET_PLACE_DETAILS] (state, details = {}) {
    const createDetails = details => ({
      ...details,
      youtubeId: details.youtube_id
    })

    state.details = [...state.details, createDetails(details)]
  },
  [SET_ACTIVE_PLACE] (state, id = -1) {
    state.active = +id
    id !== -1 && router.push({ name: 'details', params: { id } })
  },
  [TOGGLE_MODE] (state) {
    state.mode = +!state.mode
  }
}

const actions = {
  async fetchPlacesList ({ state, commit, dispatch }, id) {
    const { results = [], next } = await service.places.list(id)

    commit(SET_PLACES_LIST, results)
    if (next) dispatch('fetchPlacesList', extractPageFromUrl(next))
  },
  async setActivePlace ({ commit, dispatch }, id) {
    const isInvalidId = id < 0
    const isLoading = state.setActiveLoading
    const isAlreadyFetched = state.details.some(item => item.id === id)

    if (isInvalidId || isLoading || isAlreadyFetched) {
      commit(SET_ACTIVE_PLACE, id)
      return
    }

    commit(TOGGLE_LOADING, 'fetchDetails')
    const details = await service.places.details(id)
    commit(TOGGLE_LOADING, 'fetchDetails')

    if (typeof details !== 'object' || !details.id) {
      router.push({ name: 'map' })
      return
    }

    commit(SET_PLACE_DETAILS, details)
    commit(SET_ACTIVE_PLACE, id)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/places.js